import { Col, Row, Space } from "antd"
import { Button, CountDown, OtpInputField, Text, Title, notification } from "components/common"
import { getDeviceInoHash, performEncryption } from "configs/utils"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useVerifyMobileOTPMutation } from "../api"
import { SvgIcResetPassword } from "components/svg"
import styles from "../index.module.less"

const EmailOTPVerificationFlow = ({ challengeUserToLogin, isLoadingChallenge, setCurrentState, userState }) => {
  const { t } = useTranslation()
  const [verifyEmailOTP, { isLoading: isLoadingEmailOTP }] = useVerifyMobileOTPMutation()
  const [isOTPSentViaEmail, setIsOTPSentViaEmail] = useState(false)
  const [resetTimer, setResetTimer] = useState(Date.now() + 120 * 1000)
  const [emailOTP, setEmailOTP] = useState()

  const handleEmailOTPVerification = async () => {
    const response = await verifyEmailOTP({
      a: performEncryption(userState?.uuid),
      b: getDeviceInoHash(false, userState?.uuid),
      token: emailOTP,
    })
    if (response?.error) {
      notification.error({ message: response?.error?.message })
    } else if (response?.data?.otpVerified) {
      notification.success({ message: t("OTP verified successfully") })
      challengeUserToLogin(userState?.uuid)
      setCurrentState("default")
    }
    setEmailOTP(null)
  }
  const handleOTPValidation = async () => {
    const response = await challengeUserToLogin(userState?.uuid, true)
    if (response?.error) return
    setResetTimer(Date.now() + 120 * 1000)
    setEmailOTP(null)
    setIsOTPSentViaEmail(true)
  }
  return (
    <Space direction="vertical" size={32} className="text-center w-100">
      <div>
        <Space size={6} className="w-100 mbe-12" align="baseline" style={{ justifyContent: "center" }}>
          <Title level={2} className=" mbe-0 ">
            {t("Verify OTP")}
          </Title>
          <SvgIcResetPassword />
        </Space>

        <Text block type="secondary">
          {isOTPSentViaEmail
            ? t("An OTP has been sent to ") + userState?.email + "." + t("Please enter the OTP login.")
            : t(
                "You're reached the limit for SMS OTP requests. For continued access, please request an OTP via email."
              )}
        </Text>
      </div>
      {isOTPSentViaEmail && (
        <div>
          <OtpInputField isDisabled={isLoadingEmailOTP} otp={emailOTP} setOtp={setEmailOTP} index={6} />
          <Space>
            <Button
              type="link"
              disabled={isOTPSentViaEmail && !!resetTimer ? true : false}
              onClick={() => {
                handleOTPValidation()
              }}
              loading={isLoadingChallenge}
              text={isOTPSentViaEmail ? t("Resend OTP via Email") : t("Request OTP via Email")}
              className="p-8"
            />

            <CountDown
              value={resetTimer}
              onFinish={() => {
                setResetTimer()
              }}
              format="mm:ss"
              className={styles.countDown}
            />
          </Space>
        </div>
      )}

      <Button
        type="primary"
        size="large"
        text={isOTPSentViaEmail ? "Submit" : "Request OTP via Email"}
        onClick={() => {
          if (isOTPSentViaEmail) {
            handleEmailOTPVerification()
          } else {
            handleOTPValidation()
          }
        }}
        loading={isLoadingEmailOTP}
        block
      />
    </Space>
  )
}
export default EmailOTPVerificationFlow
